<!-- ----------------------------------------------- -->
<template>
  <v-sheet class="container-column" style="height: 100%;">
    <v-data-table
      :headers="headersList"
      :items="valuesList"
      :items-per-page="this.valuesList.length"
      item-key="cd"
      hide-default-footer
      disable-sort
      fixed-header
      height="100%"
      class="container-column"
    >
      <template v-slot:[`item.stgLevel`]="{ item }">
        <v-row>
          <!-- 超過アイコン -->
          <!-- <v-col
            class="text-right pa-0 tm-pc-detail-stage-values-tbody"
            cols="5"
            v-if="showSwStgOvlvl(item.swstgOvlvl)"
          >
            <template>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="pl-3 tm-pc-detail-stg-ovlvl-color"
                    :rw-info-color="setRwInfoColor(item.swstgOvlvl)"
                    >mdi-alert-octagram</v-icon
                  >
                </template>
                <span>{{ setSwStgOvlvlNm(item.swstgOvlvl) }}</span>
              </v-tooltip>
            </template>
          </v-col>
          <v-col v-else cols="5"></v-col> -->
          <v-col cols="5"></v-col>
          <!-- 水位データ -->
          <v-col v-if="showSwStgHighlight(item.swstgOvlvl)"
          class="tm-pc-detail-stage-values-tbody pa-0 cols=2"
          >
          <span class="tm-pc-detail-stg-ovlvl-color-highlight px-2"
          :rw-info-color="setRwInfoColor(item.swstgOvlvl)">
            {{ item.stgLevel }}
            </span>
          </v-col>
          <v-col v-else class="pa-0" cols="2">
            {{ item.stgLevel }}
          </v-col>
          <!-- 品管アイコン -->
          <v-col
            class="text-left pa-0 tm-pc-detail-stage-values-tbody"
            cols="5"
            v-if="item.isAbnrml"
          >
            <template>
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-bind="attrs" v-on="on" class="pl-3 icon-qmflg"
                    >warning</v-icon
                  >
                </template>
                <span>{{ text.abnormal }}</span>
              </v-tooltip>
            </template>
          </v-col>
          <v-col v-else cols="5"></v-col>
        </v-row>
      </template>
    </v-data-table>
  </v-sheet>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 [PC]危機管理 (詳細)観測値一覧カード
 * TmSwStageDetailValues.vue
 * @author LIS
 */

export default {
  name: "tm-sw-stage-detail-values",
  data() {
    return {
      selectTime: "min",
      text: {
        abnormal: "異常のおそれあり",
      },
    };
  },
  computed: {
    /**
     * 危機管理水位情報(10分) 取得
     */
    min10List: {
      get() {
        return this.$store.state.Swin.selectedSw.obsValues.min10;
      },
    },
    /**
     * ヘッダ情報 取得
     */
    headersList: {
      get() {
        return this.min10List.headers;
      },
    },
    /**
     * 観測値一覧 取得
     */
    valuesList: {
      get() {
        return this.min10List.values;
      },
    },
  },
  methods: {
    /**
     * 超過観測所 着色
     */
    setRwInfoColor(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "occurrence";
      } else if (stgOvlvl === 80 || stgOvlvl === 70) {
        return "danger";
      } else if (stgOvlvl === 60 || stgOvlvl === 50) {
        return "refuge";
      } else if (stgOvlvl === 40 || stgOvlvl === 30 || stgOvlvl === 20) {
        return "warn";
      }
    },
    /** 超過基準水位名を表示するか */
    showSwStgOvlvl(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    /** 超過の強調表示をするか */
    showSwStgHighlight(stgOvlvl) {
      if (30 <= stgOvlvl && stgOvlvl <= 90) {
        return true;
      }
      return false;
    },
    /**
     * 超過基準水位名の取得
     */
    setSwStgOvlvlNm(stgOvlvl) {
      if (stgOvlvl === 90) {
        return "氾濫開始水位超過";
      } else if (stgOvlvl === 80) {
        return "危険水位超過";
      } else if (stgOvlvl === 30) {
        return "水位観測中";
      }
      return "";
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped></style>
